<div class="otp-box">
  <div class="form-group otp-group">
    <label>Enter OTP sent to {{ otpSentTo }}</label>

    <div class="otp-cells" [class.shake]="shake">
      @for (i of cells; track i) {
      <input
        #cell
        type="text"
        inputmode="numeric"
        autocomplete="one-time-code"
        maxlength="6"
        [value]="digits[i]"
        [class.filled]="digits[i]"
        [class.cell-error]="!!otpError"
        class="otp-cell"
        [attr.aria-label]="'OTP digit ' + (i + 1)"
        (input)="onInput(i, $event)"
        (keydown)="onKeyDown(i, $event)"
        (paste)="onPaste($event)"
        (focus)="onFocus($event)" />
      }
    </div>

    @if (otpError) {
    <small class="error-text">{{ otpError }}</small>
    }
  </div>

  <button class="verify-btn" [disabled]="isLoading || !isComplete" (click)="verified.emit()">
    @if (isLoading) {
    <span class="spinner" role="status" aria-label="Loading"></span>
    } @else { Verify OTP }
  </button>

  <div class="resend-text mt-3">
    @if (countdown !== 0) {
    <ng-container> Resend OTP in {{ countdown }}s </ng-container>
    } @else {
    <span class="resend-link" (click)="resent.emit()">Resend OTP</span>
    }
  </div>

  <div class="resend-text mt-3">
    <span (click)="backed.emit()" class="back">Back</span>
  </div>
</div>